import React from 'react'
import PropTypes from 'prop-types'
import _isString from 'lodash/isString'
import IconV2, { ICON_TYPES } from '../../Icon.v2/index'
import Button, { TYPES } from '../../Button/index'

export const SORT_ORDER_ASC = 'ASC'
export const SORT_ORDER_DESC = 'DESC'
const baseClassName = 'button-sort'

/**
 * Button used to sort data, like table data
 * @param {String} sortOrder The sort order (ASC, or DESC)
 * @param {String} className The html class
 * @returns Class name
 */
function getClassName (sortOrder, className, inactive) {
  const name = [baseClassName]

  if ([SORT_ORDER_ASC, SORT_ORDER_DESC].includes(sortOrder)) {
    name.push(`${baseClassName}--active`)
  }

  if (className && _isString(className)) {
    name.push(className)
  }

  if (inactive) {
    name.push(`${baseClassName}--inactive`)
  }

  return name.join(' ')
}

/**
 * Button used to sort data, like table data
 * @param {String} text The button text
 * @param {String} sortOrder The sort order (asc, or desc)
 * @param {Function} onClick The onclick function
 * @param {String} className The optional class name
 * @returns Button used for sorting data
 */
function ButtonSort (props) {
  const {
    children, sortOrder, onClick, className, inactive,
  } = props
  return (
    <Button
      type={TYPES.GHOST}
      className={getClassName(sortOrder, className, inactive)}
      onClick={onClick}
    >
      {children}
      <IconV2
        type={ sortOrder === SORT_ORDER_ASC ? ICON_TYPES.ARROW_UP : ICON_TYPES.ARROW_DOWN}
        className={`${baseClassName}__icon`}
        />
    </Button>
  )
}

ButtonSort.propTypes = {
  sortOrder: PropTypes.oneOf([SORT_ORDER_ASC, SORT_ORDER_DESC, null]),
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  inactive: PropTypes.bool,
}

ButtonSort.defaultProps = {
  sortOrder: null,
}

export default ButtonSort
